<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-xl-12 mb-3">
          <b-overlay
            :show="companyLoading"
            class="rounded"
            variant="transparent"
          >
            <template #overlay>
              <b-img
                width="100"
                :src="require('@/assets/img/brand/loader.gif')"
                alt=""
              />
            </template>
            <card shadow class="rounded">
              <div slot="header" class="border-0">
                <div class="row align-items-center">
                  <div>
                    <base-button
                      type="primary"
                      class="ml-3"
                      size="sm"
                      @click="$router.back()"
                      ><i class="ni ni-bold-left"></i
                    ></base-button>
                    <span class="mb-0 h3">{{ getShowCompany.name }}</span>
                  </div>

                  <b-button
                    class="ml-auto"
                    size="sm"
                    @click="
                      $router.push({
                        name: 'term_condition_by_company',
                        params: {
                          id: $route.params.id,
                        },
                      })
                    "
                    >{{ $t("conditions") }}</b-button
                  >
                  <b-button class="float-right" size="sm" variant="primary">
                    <i class="ri-facebook-line"></i>
                  </b-button>
                  <b-button class="float-right" size="sm" variant="info">
                    <i class="ri-twitter-line"></i>
                  </b-button>
                  <b-button class="float-right" size="sm" variant="danger">
                    <i class="ri-instagram-line"></i>
                  </b-button>
                  <b-button class="float-right" size="sm" variant="dark">
                    <i class="fab fa-tiktok"></i>
                  </b-button>
                </div>
              </div>
              <template>
                <div class="pl-lg-4">
                  <ShowDetails />
                </div>
              </template>
            </card>
          </b-overlay>
          <b-row>
            <b-col md="12" class="my-3">
              <users-table :title="$t('users')" :modal="true"></users-table>
            </b-col>
            <b-col md="12" class="my-3">
              <visits-table :title="$t('visits')"></visits-table>
            </b-col>
            <b-col md="12" class="my-3">
              <transactions-table :title="$t('transactions')"></transactions-table>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { myRendeImage } from "@/directives/render-Image";
import UsersTable from "../Users/UsersTable.vue";
import VisitsTable from "../Visits/VisitsTable.vue";
import TransactionsTable from "./Transactions/TransactionsTable.vue";

import ShowDetails from "./Component/ShowDetails.vue";

export default {
  name: "show-company",
  mixins: [myRendeImage],
  components: {
    ShowDetails,
    UsersTable,
    VisitsTable,
    TransactionsTable,
  },
  data() {
    return {
      model: {},
      id: this.$route.params.id,
      showImage: false,
      points: 0,
    };
  },
  async created() {
    await this.getCompany(this.id);
    await this.getCompanyPoints(this.id);
  },
  methods: {
    ...mapActions({
      getCompany: "fetchShowCompany",
      getCompanyPoints: "getCompanyPoints",
    }),
  },
  computed: {
    ...mapGetters({
      companyLoading: "companyLoading",
      getShowCompany: "getShowCompany",
    }),
  },
};
</script>

<style>
@supports (object-fit: cover) {
  .box img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center center;
  }
}
</style>
